export enum ShareTypeModel {
  None = 0,
  Internal = 1,
  Full = 2,
}
